<template>
  <!-- 分页器 -->
    <div class="pagination" v-if="pageTotal>1">
      <ul>
      <li class="first" @click="goPage('first')" v-if="curPage!=1"><span></span></li>
      <li class="prev"  @click="goPage('prev')"  v-if="curPage!=1"><span></span></li>
      <!-- 第一页 -->
      <li :class="{'active':curPage == 1}" @click="goPage(1)"><span>1</span></li>
      <!-- 中间省略号 -->
      <li v-if="showPageStart-1 > 1 && pageTotal>pageItemCount">...</li>

      <template v-for="item in (pageTotal >pageItemCount?pageItemCount:pageTotal)" >
        <li 
          :class="{'active':curPage ==  showPageStart+item-2}" 
          @click="goPage(showPageStart+item-2)" 
          v-if="item>1 && item<(pageTotal >pageItemCount?pageItemCount:pageTotal)">
          <span>{{showPageStart+item-2 }} </span>
        </li>
      </template>

      <!-- 中间省略号 -->
      <li v-if="pageTotal > showPageEnd+1 && pageTotal>pageItemCount" >...</li>
      
      <!-- 最后一页 -->
      <li :class="{'active':curPage == pageTotal}" v-if="pageTotal>1" @click="goPage(pageTotal)"><span>{{pageTotal}}</span></li>

      <li class="next"  @click="goPage('next')"  v-if="curPage!=pageTotal"><span></span></li>
      <li class="last"  @click="goPage('last')"  v-if="curPage!=pageTotal"><span></span></li>
      <li class="jump"  v-if="pageTotal>1">转至第 <input type="text" v-model="jumpPage" class="pagination-input" @change="goPage(jumpPage)"> 页</li>
      <li>共{{total}}项，共{{pageTotal}}页</li>
      </ul>
    </div>
    <!-- 分页器 -->
</template>

<script>
export default {
  name: 'nagination',
  props: {
    total:{
      type:Number,
      default:1
    },
    curPage:Number,
    pageSize:Number
  },
  data(){
    return{
      jumpPage:'',
      showPageEnd: 7,
      showPageStart:2,
      pageItemCount:7,
    }
  },
  computed:{
    pageTotal(){
      return Math.ceil(this.total/this.pageSize)
    }
  },
  watch:{
    curPage:{
      handler(newval,oldval){
        if(newval ){
          this.jumpPage = newval;
          if(this.pageTotal > this.pageItemCount){
            if(newval <= (this.pageItemCount-3)/2){
              this.showPageStart=2
              this.showPageEnd = this.pageItemCount -1
            }else if(newval >= this.pageTotal -(this.pageItemCount-3)/2){
              this.showPageStart = Math.ceil(this.pageTotal - this.pageItemCount +2)
              this.showPageEnd = this.pageTotal
            }else{
              this.showPageStart = Math.ceil(newval -((this.pageItemCount -3) /2))
              if(this.showPageStart <2){
                this.showPageStart=2
              }
              this.showPageEnd = Math.ceil(newval +((this.pageItemCount -3) /2))
            }
          }else{
            this.showPageStart =2
            this.showPageEnd = this.pageTotal
          }
        }
      },
      immediate:true
    }
  },
  methods: {
    goPage(info){
      // info = parseInt(info);
      if(this.curPage == info){
        return;
      }
      let clickPage =0;
      if(info <=0 || info > this.pageTotal){
        alert("请输入正确页码")
        return;
      }
      
      if(info>0){
        clickPage = parseInt(info);
      }else{
        clickPage=this.curPage;
        switch(info){
          case "first": clickPage=1; break;
          case "prev": clickPage --;break;
          case "next":clickPage ++; break;
          case "last": clickPage = this.pageTotal;break;
        }
      }
      this.$emit("clickPage",{topage:clickPage})
    }
  },
}
</script>